import { APP_ROUTES, AuthMethodRoute } from 'constants/routes';
import {
	AccessKeysPage,
	AuditsPage,
	AuthenticationMethodsPage,
	FlowBuilderPage,
	FlowsPage,
	GettingStartedPage,
	HelpPage,
	HomePage,
	SingleTenantPage,
	TenantsPage,
	UsersPage
} from 'pages';
import AuthorizationPage from 'pages/Authorization/AuthorizationPage';
import CompanyPage from 'pages/Settings/Company/CompanyPage';
import ProjectSettingsSkeleton from 'pages/Settings/ProjectSettings/ProjectSettingsSkeleton';
import StyleEditor from 'pages/StyleEditor';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Redirect from 'routes/Redirect';

const AuthenticatedAppRoutes = () => (
	<Routes>
		<Route
			path={APP_ROUTES.default}
			element={<Navigate to={APP_ROUTES.home} replace />}
		/>
		<Route path={APP_ROUTES.home} element={<HomePage />} />
		<Route path={APP_ROUTES.gettingStarted} element={<GettingStartedPage />} />
		<Route path={APP_ROUTES.users} element={<UsersPage />} />
		<Route path={APP_ROUTES.audits} element={<AuditsPage />} />
		<Route path={APP_ROUTES.accessKeys} element={<AccessKeysPage />} />
		<Route path={APP_ROUTES.authorization} element={<AuthorizationPage />} />
		<Route path={APP_ROUTES.roles} element={<AuthorizationPage />} />
		<Route path={APP_ROUTES.permissions} element={<AuthorizationPage />} />
		<Route path={APP_ROUTES.tenants} element={<TenantsPage />} />
		<Route
			path={APP_ROUTES.tenantDetails}
			element={<Redirect to={`${APP_ROUTES.tenantDetails}/details`} replace />}
		/>
		<Route path={APP_ROUTES.tenant} element={<SingleTenantPage />} />

		<Route
			path={APP_ROUTES.authMethods}
			element={<AuthenticationMethodsPage authPage={AuthMethodRoute.OTP} />}
		/>
		<Route
			path={APP_ROUTES.authMethodsOTP}
			element={<AuthenticationMethodsPage authPage={AuthMethodRoute.OTP} />}
		/>
		<Route
			path={APP_ROUTES.authMethodsMagicLink}
			element={
				<AuthenticationMethodsPage authPage={AuthMethodRoute.MagicLink} />
			}
		/>
		<Route
			path={APP_ROUTES.authMethodsEnchantedLink}
			element={
				<AuthenticationMethodsPage authPage={AuthMethodRoute.EnchantedLink} />
			}
		/>
		<Route
			path={APP_ROUTES.authMethodsSocial}
			element={<AuthenticationMethodsPage authPage={AuthMethodRoute.Social} />}
		/>
		<Route
			path={APP_ROUTES.authMethodsSSO}
			element={<AuthenticationMethodsPage authPage={AuthMethodRoute.SSO} />}
		/>
		<Route
			path={APP_ROUTES.authMethodsWebAuthn}
			element={
				<AuthenticationMethodsPage authPage={AuthMethodRoute.WebAuthn} />
			}
		/>
		<Route
			path={APP_ROUTES.authMethodsTOTP}
			element={<AuthenticationMethodsPage authPage={AuthMethodRoute.TOTP} />}
		/>
		<Route
			path={APP_ROUTES.authMethodsPassword}
			element={
				<AuthenticationMethodsPage authPage={AuthMethodRoute.Password} />
			}
		/>
		<Route
			path={APP_ROUTES.projectSettings}
			element={<ProjectSettingsSkeleton />}
		/>
		<Route path={APP_ROUTES.flows} element={<FlowsPage />} />
		<Route path={APP_ROUTES.flowsBuilder} element={<FlowBuilderPage />} />
		<Route path={APP_ROUTES.flowsBuilderEdit} element={<FlowBuilderPage />} />
		<Route path={APP_ROUTES.flowStyleEditor} element={<StyleEditor />} />
		<Route
			path={APP_ROUTES.company}
			element={<Redirect to={APP_ROUTES.companySettings} replace />}
		/>
		<Route path={APP_ROUTES.companySettings} element={<CompanyPage />} />
		<Route path={APP_ROUTES.companyAdmins} element={<CompanyPage />} />
		<Route path={APP_ROUTES.companyManagementKeys} element={<CompanyPage />} />

		<Route path={APP_ROUTES.help} element={<HelpPage />} />
		<Route path="*" element={<Redirect to={APP_ROUTES.notFound} replace />} />
	</Routes>
);

export default AuthenticatedAppRoutes;
